import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import Moment from 'moment';
import agent from '../../../api/agent';
import { sendToSalesFlow, setDigitalData } from '../../Utilities/Utils.js';
import ReactGA from 'react-ga';

import './Waiver.css';

class DGRWaiver extends Component {

    html = ''

    componentDidMount(){
        this.props.DGRBackgroundStore.showBlurAndHeader()
         
        if (this.props.DGRStore.debugMode === false){
            //REQUIRE POPULATED USER FIELDS
            const { first_name, last_name, zipcode, phone, gender, membership_flow} = this.props.DGRStore.values;
            const { birthday } = this.props.DGRStore
            if (!first_name || !last_name || !zipcode || !phone || !gender || !birthday) {
                //direct based on membership_flow
                if (membership_flow){
                    return this.props.history.push('lead');
                }else{
                    return this.props.history.push('create_pass');
                }
            }
        }
        //FETCH WAIVER DATA BY STATE
        this.fetchExternalHTML()
        setDigitalData( 'sign waiver', this.props.DGRStore.club_number );
    }
    fetchExternalHTML(){
        const {address_state}  = this.props.DGRStore.clubValues
        agent.DGR.externalHTMLWaiverPage(address_state ).then( (response) => {
            this.html = response
            this.forceUpdate()
        })
    }
    
    cancelPressed = (e) => {
        this.props.DGRStore.clearValues()
        this.props.history.push('');
    }

    agreePressed = (e) => {
        ReactGA.set({ dimension7: new Date().getTime() });
        ReactGA.event({
            category: 'Sign Waiver',
            action: 'I Agree'
        });

        this.props.DGRStore.setValue("is_waiver_signed" , true);
        // Set the Return Visit Sent as true, so that we don't do it on the following screens.
        this.props.DGRStore.values.return_visit_sent = true;
        const { membership_flow} = this.props.DGRStore.values;
        const { birthday } = this.props.DGRStore
        var duration = Moment.duration(Moment().diff(birthday)).asYears()
        if (duration < 18) {
            this.props.history.push('under_18');
            return
        }

        this.props.DGRStore.createPass().then( () => {
            if ( membership_flow ){
                const { club_product_id, club_number } = this.props.DGRStore 
                sendToSalesFlow( club_product_id, club_number, this.props.DGRStore.values );
            } else {
                this.props.history.push('first_visit');
            }
        });
    }
    
    createMarkup(){
        if (this.html){
            return { __html: this.html }
        }else{
            return {__html: '<div class="ext"></div>'};
        }
    }


    showWaiverIfLoaded(){
        if (this.html){
            return(
                <div>
                    <div dangerouslySetInnerHTML={this.createMarkup()}/>
                </div>
            )
        }else{
            return(
                <div className="loader">
                </div>
            )
        } 
    }

    render(){
		return (
                <div className="waiver">
                    <div className="dgrTitleText">
                        <h1>Please Review the Terms</h1>
                    </div>
                    <div className="dgrTitleSubText">
                        <div className="subText">
                             Photo identification required.  If under 18 years of age, a parent or guardian must be present.
                        </div>
                    </div>
                    <div className="waiverBody">
                    <div className="waiverText">
                        {this.showWaiverIfLoaded()}   
			        </div>
                    </div>
                    <div className="waiverButton">
                        <button 
                            disabled={ this.html ? false : true } 
                            className="bigButton" 
                            onClick={this.agreePressed}>
                            I Agree
                        </button>
                </div>
            </div>
		)
    }
}

DGRWaiver = inject('DGRStore','DGRModalStore', 'DGRBackgroundStore')(observer(DGRWaiver ))     
export default DGRWaiver 



// WEBPACK FOOTER //
// ./src/components/DGR/Waiver/Waiver.js